import * as React from "react";

const GoogleCallback: React.FC = () => {
  React.useEffect(() => {
    try {
      // Get the id_token from the URL hash
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const idToken = params.get("id_token");
      const error = params.get("error");
      const errorDescription = params.get("error_description");
      if (error || !idToken) {
        throw new Error(errorDescription || error || "No ID token received from Google");
      }
      // Send the token back to the taskpane
      Office.context.ui.messageParent(
        JSON.stringify({
          type: "google-signin",
          credential: idToken,
        })
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error processing Google Sign-In response:", error);
      Office.context.ui.messageParent(
        JSON.stringify({
          type: "error",
          message: error.message || "Failed to process Google Sign-In response",
        })
      );
    }
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <h2>Processing Sign In...</h2>
      <p>Please wait while we complete your sign in.</p>
    </div>
  );
};

export default GoogleCallback;
